export var ICategoryTile;
(function (ICategoryTile) {
    /**
     * used in https:www.figma.com/file/XBKfeoIzmZdUqB0dyDeq1z/Homepage-strategy-2024?type=design&node-id=6187-55146&mode=design&t=fqacRa58UPnH2jpI-0
     */
    let CategoryTileVariant;
    (function (CategoryTileVariant) {
        CategoryTileVariant["CATEGORY_TILE_VARIANT_UNKNOWN"] = "CATEGORY_TILE_VARIANT_UNKNOWN";
        /**
         * Used for rectangular category tiles on web & mobile
         */
        CategoryTileVariant["RECTANGLE"] = "RECTANGLE";
        /**
         * Used for circular category tile on web & mobile
         */
        CategoryTileVariant["CIRCLE"] = "CIRCLE";
        /**
         * Used for small circular category tile on web & mobile
         */
        CategoryTileVariant["SMALL_CIRCLE"] = "SMALL_CIRCLE";
    })(CategoryTileVariant = ICategoryTile.CategoryTileVariant || (ICategoryTile.CategoryTileVariant = {}));
    /**
     * Return an instance of ICategoryTile with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ICategoryTile.build = (partial) => (Object.assign({ images: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ICategoryTile || (ICategoryTile = {}));
